import { createSelector } from '@reduxjs/toolkit';
import { selectElevatorsValue } from './selectElevatorsValue';
import { EElevatorType } from '../../../../packages/JsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Есть любой', value: EElevatorType.Any },
  { label: 'Есть грузовой', value: EElevatorType.Service },
];

export const selectElevatorsFilter = createSelector(selectElevatorsValue, value => ({
  label: 'Лифт',
  value: [value],
  options: OPTIONS,
}));
